// extracted by mini-css-extract-plugin
export default {"stepDot":"styles_stepDot__M3dU0","stepDotActive":"styles_stepDotActive__n9ML8"};